import React from 'react';

function useLocalStorage(itemName, initialValue) {
  const [state, dispatch] = React.useReducer(reducer, initialState({initialValue}));
  const {
    item,
    loading,
    error,
  } = state

  const onError = () => dispatch({type: actionTypes.error})
  const onSuccess = (item) => dispatch({ type: actionTypes.success, payload: item})
  const onSave = (item) => dispatch({ type: actionTypes.save, payload: item})
  
  React.useEffect(() => {
    const localStorageItem = localStorage.getItem(itemName);
    let parsedItem;

    const handleStorageChange = (event) => {
      if (event.key === itemName) {
        const updatedItem = JSON.parse(event.newValue);
        onSuccess(updatedItem);
      }
    };
  
    window.addEventListener('storage', handleStorageChange);
  
    setTimeout(() => {
      try {
  
        if (!localStorageItem) {
          const defaultTodos = [
            { text: "Ejemplo sin completar", completed: false },
            { text: "Ejemplo completado", completed: true },
          ];
          localStorage.setItem(itemName, JSON.stringify(defaultTodos));
          parsedItem = defaultTodos;
        } else {
          parsedItem = JSON.parse(localStorageItem);
        }
        onSuccess(parsedItem)
      } catch(error) {
        onError()
      }

      console.log(
        `Hola ya que llegaste hasta aqui, si deseas tener tus TODOS por defecto, los iniciales copia esto y ejecutalo...
        
        localStorage.removeItem("TODOS__DEFAULT--v1")`
        )
    }, 2000);
    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, [itemName, onError, onSuccess]);

  const saveItem = (newItem) => {
    const strigifieldItem = JSON.stringify(newItem)
    localStorage.setItem(itemName, strigifieldItem);
    onSave(newItem)
  };

  return {
    item,
    saveItem,
    loading,
    error,
  };
}

const initialState = ({initialValue}) => ({
  item : initialValue,
  loading : true,
  error: false,
})

const actionTypes = {
  error: "ERROR",
  success: "SUCCESS",
  save: "SAVE",
}

const reducerObject = (state, payload) => ({
  [actionTypes.error]: {
    ...state,
    loading: false,
    error: true
  },
  [actionTypes.success]: {
    ...state,
    error: false,
    loading: false,
    item : payload
  },
  [actionTypes.save]: {
    ...state,
    item: payload,
  }
})

const reducer = (state, action) => {
  return reducerObject(state, action.payload)[action.type] || state;
}
export { useLocalStorage };